import {configureStore} from "@reduxjs/toolkit";
import projectReducer, {
    projectInfoSlice,
    unitySlice,
    invitesSlice,
    redirectSlice,
    enterpriseUserInfoSlice
} from "../features/states/slices";
import {loginSlice} from "../features/states/slices";

export const store = configureStore({
    reducer: {
        projectList: projectReducer,
        loginToken: loginSlice.reducer,
        OpenInUnity: unitySlice.reducer,
        projectInformation: projectInfoSlice.reducer,
        invitesList: invitesSlice.reducer,
        routeRedirect: redirectSlice.reducer,
        enterpriseUserInfo: enterpriseUserInfoSlice.reducer
    },
});
